<template>
	<component :is="currentComponent" />
</template>

<script>
import { mapState } from 'vuex'

import InVenueTime from './InVenueTime.vue'
import PickUpTime from './PickUpTime.vue'

export default {
	name: 'TimeView',

	components: { PickUpTime, InVenueTime },

	computed: {
		...mapState('cart', ['isPickUp']),

		currentComponent() {
			return this.isPickUp ? 'PickUpTime' : 'InVenueTime'
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';

.pick-up-time {
	display: inline-flex;
	align-items: center;
	padding: 5px 4px;
	cursor: pointer;
	color: $white;
	border: 1px solid $border-color;
	background-color: $background-box;
	border-radius: 12px;
	pointer-events: none;

	&.accept-both {
		&.for-here {
			padding-right: 20px;
			border-right: none;
			border-bottom-right-radius: 0;
			border-top-right-radius: 0;
		}

		&.to-go {
			padding-left: 20px;
			border-left: none;
			border-bottom-left-radius: 0;
			border-top-left-radius: 0;
		}
	}
}

.pick-up-time-status {
	display: flex;
	align-items: center;

	.pick-up-time-status-icon {
		margin-right: 4px;
	}
}

.pick-up-time-value {
	display: flex;
	align-items: center;
	font-size: 12px;
	line-height: 15px;
	letter-spacing: 0.6px;

	.pick-up-time-value-separator {
		width: 3px;
		height: 3px;
		margin: 0 6px;
		border-radius: 50%;
		background-color: $grey-alfa;
	}

	.pick-up-time-value-separator,
	.pick-up-time-value-name {
		color: $white;
	}
}

.pick-up-time-vertical-separator {
	height: 28px;
	padding: 5px 0;
	border-top: 1px solid;
	border-bottom: 1px solid;
	border-color: $grey-alfa;

	div {
		width: 1px;
		height: 16px;
		background-color: $grey-alfa;
	}
}

.pick-up-time-value-type {
	white-space: nowrap;
}

@media (max-width: 600px) {
	.pick-up-time {
		&.accept-both {
			&.for-here {
				padding-right: 8px;
			}

			&.to-go {
				padding-left: 8px;
				flex-grow: 1;
			}
		}

		&.pickup {
			width: fit-content;
		}

		.pick-up-time-status-icon {
			margin-right: 2px;
		}

		.pick-up-time-value {
			font-size: 10px;
			line-height: 12px;
			letter-spacing: 0;

			.pick-up-time-value-separator {
				margin: 0 4px;
			}
		}
	}
}

@media (max-width: 400px) {
	.pick-up-time {
		&.accept-both {
			&.for-here {
				padding-right: 5px;
				padding-left: 4px;
			}

			&.to-go {
				padding-left: 5px;
				padding-right: 4px;
			}
		}

		.pick-up-time-value {
			.pick-up-time-value-separator {
				margin: 0 3px;
			}
		}
	}
}
</style>
